import React, { useState } from "react";
import { useContext } from "react";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";


const Button = (props) => {
    const {levels, chooseLevel, chooseStage} = useContext(MemoryLevelContext);

    const sendLevelChoice = ( level, levelName, isSet) => {
        if(levels.level.levelIsSet == false){
            chooseLevel(level, levelName, isSet);
        } else if(levels.stage.stageIsSet == false){
            chooseStage( level, levelName, isSet);
        }
    };

    const nameTranslation = (name) => {
        switch (name){
            case "Nybörjarbonden":
                return "Börja spela";
            default:
                return name;
        }
    };

    return (
        <span className="button-container">
            <button className="button" onClick={() => sendLevelChoice( props.value, props.name, true)}>
                <span className="label button--label">{nameTranslation(props.name)}</span>
                <span className="button--icon-container">
                    <i className="arrow arrow--right arrow--button" aria-hidden="true"></i>
                </span>
            </button>
        </span>
    );
};

export default Button;